import React from 'react';

import './loader.component.scss';

const Loading = () => (
	<div className="card-loader">
		<div className="loader-2 center"><span /></div>
	</div>
);

export default Loading;
